import { TimeTradingEnum } from '../SalariedDirectorFields/types';

export const ContractorFieldsQuestions = {
  timeTrading: {
    titleKey: 'affordabilityCalculator.contractor.timeTrading.title',
    textKey: 'affordabilityCalculator.contractor.timeTrading.text',
    options: [
      {
        labelKey: 'affordabilityCalculator.contractor.timeTrading.lessTime',
        value: TimeTradingEnum.lessThanTwoYears,
      },
      {
        labelKey: 'affordabilityCalculator.contractor.timeTrading.moreTime',
        value: TimeTradingEnum.moreThanTwoYears,
      },
    ],
  },
  timeRemaining: {
    titleKey: 'affordabilityCalculator.contractor.timeRemaining.title',
    textKey: 'affordabilityCalculator.contractor.timeRemaining.text',
    placeholdersKeys: [
      'affordabilityCalculator.contractor.timeRemaining.years.placeholder',
      'affordabilityCalculator.contractor.timeRemaining.months.placeholder',
    ],
  },
  netTaxableIncomeRecentYear: {
    titleKey: 'affordabilityCalculator.contractor.netTaxableIncomeRecentYear.title',
  },
  netTaxableIncomePreviousYear: {
    titleKey: 'affordabilityCalculator.contractor.netTaxableIncomePreviousYear.title',
  },
  error: {
    required: 'common.error.requiredField',
  },
};
